import { Component, Vue } from 'vue-property-decorator';
import ClientDataTableReport from '@/model/service/client/report/client-data-table-report';

@Component
export default class ClientIndex extends Vue
{
    protected report: ClientDataTableReport|null = null;

    private created()
    {
        this.report = new ClientDataTableReport(this.$serviceContainer);
    }
}